<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showHeader="true"
    :showMore="false"
    :title="params.title"
    :showBorderRadius="pattern.showBorderRadius"
    :boxType="pattern.boxType"
  >
    <div slot="content" class="margin-top">
      <div class="cate-section">
        <div
          class="cate-item"
          :class="{'margin-top':index>=3}"
          v-for="(item,index) in data"
          :key="index"
          @click="navToDetailPage(item,index)"
        >
          <van-image lazy-load
            height="60"
            class="flex-1"
            :class="{borderRadius:pattern.imageBorderRadius}"
            :src="item.src"
          />
          <div v-if="(index+3)%3<2" class="width"></div>
        </div>
      </div>
    </div>
  </m-base>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          title: '友情链接'
        }
      }
    },
    data: {
      type: Array,
      default: () => []
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showBorderRadius: false,
          boxType: 'block',
          imageBorderRadius: true
        }
      }
    },
  },
  data () {
    return {

    };
  },
  mounted () {
    if (this.data.length == 0) {
      this.defaultDataList()
    }
  },
  created () {

  },
  methods: {
    defaultDataList () {
      this.data = [{
        src: '/static/temp/c1.png',
        navTo: '/pages/course/course'
      },
      {
        src: '/static/temp/c2.png',
        navTo: ''
      },
      {
        src: '/static/temp/c3.png',
        navTo: ''
      },
      {
        src: '/static/temp/c4.png',
        navTo: ''
      },
      {
        src: '/static/temp/c5.png',
        navTo: ''
      },
      {
        src: '/static/temp/c6.png',
        navTo: ''
      }
      ]
    },
    navToDetailPage (item, index) {
      let navTo = item.navTo
      if (navTo) {
        if (navTo.indexOf('http') > -1) {
          window.location.href = navTo
        } else {
          this.$router.push(this.$uitl.getPathQuery(navTo))
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
/* 分类 */
.cate-section {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  background-color: white;

  .cate-item {
    display: flex;
    flex-direction: row;
    width: 33%;
    align-items: center;
    font-size: $uni-font-size-sm + 1px;
    color: $font-color-dark;
  }

  /* 原图标颜色太深,不想改图了,所以加了透明度 */
  img {
    width: 100%;
    margin-bottom: 7px;
  }

  .borderRadius {
    border-radius: 5px;
    overflow: hidden;
  }
}

.margin-top {
  margin-top: 10px;
}
.width {
  width: 10px;
}
</style>
